import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import AddStoreBanner from './AddStoreBanner';
import StoreBannerTable from './StoreBannerTable';
import getAccess from '../../../utils/getAccess';

const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    )
}
TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
const StoreBanner = () => {
    const d = getAccess();
    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={handleChange}>
                    <Tab label="All Store Banner" {...a11yProps(0)} />
                    {(d?.accessForTab?.includes('readWrite') || d?.access?.includes('all')) &&
                        <Tab label="Add Store Banner" {...a11yProps(1)} />}
                </Tabs>
            </Box>

            <TabPanel value={value} index={0}>
                <StoreBannerTable />
            </TabPanel>

            <TabPanel value={value} index={1}>
                {(d?.accessForTab?.includes('readWrite') || d?.access?.includes('all')) &&
                    <AddStoreBanner />}
            </TabPanel>
        </Box>
    );
};


export default StoreBanner